<template>
    <el-dialog :title="(isEdit ? '编辑' : '添加') + '配件信息'" :visible.sync="visible" append-to-body v-dialogDrag width="400px"
        :close-on-click-modal="false">
        <el-form :model="form" status-icon :rules="rules" ref="form" label-position="right" label-width="100px">
            <el-row :gutter="10">
                <!-- <el-col :span="24">
                  <el-form-item label="拆解机构">
                    <StationSelect
                      v-model="form.OrgId"
                      :isShow="true"
                    ></StationSelect>
                  </el-form-item>
                </el-col> -->
                <el-col :span="24">
                    <el-form-item label="配件名称" prop="PartsName">
                        <el-input v-model="form.PartsName" placeholder="配件名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="单位" prop="Unit">
                        <!-- <el-input v-model="form.Unit" placeholder="单位"></el-input> -->
                        <RemoteSelect
                            v-model="form.Unit"
                            url="DataDic/GetItemsByType?dicType=CommonUnit"
                            code="DicName"
                            name="DicName">
                        </RemoteSelect>
                    </el-form-item>
                </el-col>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button type="primary" @click="save" :loading="loading">保 存</el-button>
                <el-button type="canale" @click="visible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </template>
    
<script>
export default {
    props: ["item"],
    components: {
    },
    data() {
        return {
            visible: false, 
            loading: false,
            isable: true,
            isEdit: false,
            form: {},
            rules: {
                // OrgId: [
                //     {
                //         required: true,
                //         message: "不可为空",
                //     },
                // ],
                PartsName: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                    this.$g.validLen(50),
                ],
                Unit: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                    this.$g.validLen(5),
                ],
            },
        };
    },
    computed: {
    },
    watch: {
        item: {
            handler: function (v) {
                if (v.PartsId) {
                    this.isEdit = true;
                    this.$get("VehicleParts/GetModel", {
                        PartsId: v.PartsId,
                    }).then((r) => {
                        this.init({ ...r.Result });
                    });
                } else {
                    this.init({});
                    this.isEdit = false;
                }
                this.visible = true;
            },
        },
    },
    methods: {
        init(form) {
            this.form = { ...form };
            if (this.$refs["form"]) {
                this.$refs["form"].resetFields();
            }
        },
        save() {
            this.$refs["form"].validate((valid) => {
                if (!valid) {
                    return;
                }
                let params = { ...this.form };
                this.loading = true;
                if (this.isEdit) {
                    this.$put("VehicleParts/Edit", params)
                        .then((r) => {
                            this.$message.success("修改成功");
                            this.visible = false;
                            this.$emit("success");
                        })
                }
                else {
                    this.$post("VehicleParts/Add", params)
                        .then((r) => {
                            this.$message.success("添加成功");
                            this.visible = false;
                            this.$emit("success");
                        })
                }
                this.loading = false;
            });
        },
    },
};
</script>    
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
    margin-top: 10px;
    @include font_color("text-color2");
}
</style>